export { default } from "./ChallengesTeacherReport";
